/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb2niw_CarddetailsInputs */

const en_visa_eb2niw_carddetails = /** @type {(inputs: Visa_Eb2niw_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An EB-2 option that may waive the job-offer and labor-certification requirements when the legal national-interest standard is met.`)
};

const pt_visa_eb2niw_carddetails = /** @type {(inputs: Visa_Eb2niw_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opção EB-2 que pode dispensar oferta de emprego e certificação trabalhista quando o padrão jurídico de interesse nacional é atendido.`)
};

const es_visa_eb2niw_carddetails = /** @type {(inputs: Visa_Eb2niw_CarddetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opción EB-2 que puede eximir la oferta de empleo y certificación laboral cuando se cumple el estándar legal de interés nacional.`)
};

/**
* | output |
* | --- |
* | "An EB-2 option that may waive the job-offer and labor-certification requirements when the legal national-interest standard is met." |
*
* @param {Visa_Eb2niw_CarddetailsInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb2niw_carddetails = /** @type {((inputs?: Visa_Eb2niw_CarddetailsInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb2niw_CarddetailsInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb2niw_carddetails(inputs)
	if (locale === "es") return es_visa_eb2niw_carddetails(inputs)
	return en_visa_eb2niw_carddetails(inputs)
});